import React from 'react'
import PropTypes from 'prop-types'
import cx from 'classnames'

export default function Calendar({ theme, ...props }) {
  return (
    <svg
      aria-labelledby={props.ariaTags.labelledBy}
      aria-hidden={props.ariaTags.hidden}
      className={cx(theme.container, theme[props.svg], props.className)}
      shapeRendering="geometricPrecision"
      tabIndex={props.tabIndex}
      vectorEffect="non-scaling-stroke"
      viewBox="-3 -4 40 40"
      xmlns="http://www.w3.org/2000/svg"
    >
      {props.title ? (
        <title id={props.ariaTags.labelledBy} lang="en">
          {props.title}
        </title>
      ) : null}
      <g
        className={theme.stroke}
        fill="none"
        fillRule="evenodd"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <path d="M4.61737021 16.4029766H28.3712851M4.61737021 24.0879426H28.3712851M11.7976298 29V12M20.9824021 29V12M1.41619149 31.9399787H31.4499149V1.19589362H1.41619149zM1.4969234 8.56604468h29.8727872" />
        <path d="M8.64117021 6.36445106c-.73278723 0-1.32706383-.59361702-1.32706383-1.3277234 0-.73278723.5942766-1.32640426 1.32706383-1.32640426.73278724 0 1.32706383.59361703 1.32706383 1.32640426 0 .73410638-.59427659 1.3277234-1.32706383 1.3277234zM24.6786574 6.36445106c-.7327872 0-1.3270638-.59361702-1.3270638-1.3277234 0-.73278723.5942766-1.32640426 1.3270638-1.32640426.7327873 0 1.3277235.59361703 1.3277235 1.32640426 0 .73410638-.5949362 1.3277234-1.3277235 1.3277234z" />
      </g>
    </svg>
  )
}

Calendar.propTypes = {
  ariaTags: PropTypes.object.isRequired, // eslint-disable-line react/forbid-prop-types
  svg: PropTypes.string.isRequired,
  theme: PropTypes.object.isRequired, // eslint-disable-line react/forbid-prop-types
  className: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
}
